import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined
import { useNavigate } from 'react-router-dom';

const AddVP = () => {
    const [name, setName] = useState('');
    const [aname, setAName] = useState('');
    const [image, setImage] = useState(null);
    const [amount, setAmount] = useState('');
    const [status, setStatus] = useState('pending');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Handle form submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        const formData = new FormData();
        formData.append('name', name);
        formData.append('aname', aname);
        formData.append('image', image); // Image will be handled as FormData
        formData.append('amount', amount);
        formData.append('status', 'pending');

        try {
            const response = await fetch(`${BASE_URL}vp`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (data.status === 1) {
                alert('VP created successfully');
                navigate('/VPList'); // Redirect to VPList after successful creation
            } else {
                alert('Error creating VP');
            }
        } catch (error) {
            console.error('Error creating VP:', error);
            alert('An error occurred while creating the VP');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add New Vpp</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Create a New Vpp</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            placeholder="Enter Customer Name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Angadia Name</label>
                                        <input
                                            type="text"
                                            id="aname"
                                            className="form-control"
                                            placeholder="Enter Angadia Name"
                                            value={aname}
                                            onChange={(e) => setAName(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={(e) => setImage(e.target.files[0])}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            placeholder="Enter Amount"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            required
                                        />
                                    </div>

                                   

                                    <div className="text-end">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? 'Creating...' : 'Create Vpp'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddVP;
